<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Credentials

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">


            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Name </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Name"
                                         pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                         maxlength="100" />
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">NO</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="NO"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Issuing Authority</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Issuing Authority"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Valid From</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Valid From"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Valid To</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Valid To"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Additional Info</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Additional Info"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Remarks</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Remarks"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>


      </div>
      
    </div>
  </div>
</div>
